export default class Template {
    constructor(width, height, size) {
        this.canvas = document.createElement("canvas");
        this.ctx = this.canvas.getContext("2d");
        this.width = width;
        this.height = height;
        this.size = size;
        this.gemSize = this.width / size;
        this.arr = [];
        this.arr1 = [];
        this.randArr = JSON.parse(localStorage.getItem("arr")) || [];
        this.localArr = JSON.parse(localStorage.getItem("arr"));
        this.empty = {};
        this.clicks = 0;
        this.clicker = document.createElement("div");
        this.highscore = {};

        this.canvas.addEventListener("click", e => {
            let x = Math.floor((e.pageX - this.canvas.offsetLeft) / this.gemSize);
            let y = Math.floor((e.pageY - this.canvas.offsetTop) / this.gemSize);
            this.move(x, y);
            this.isVictory();
            this.rerender();
        });
    }

    save() {
        localStorage.removeItem("arr");
        localStorage.setItem("arr", JSON.stringify(this.randArr));
    }

    renderClicker() {
        let span = document.createElement("span");
        document.body.append(this.clicker);
        this.clicker.append(span);
        this.clicker.classList.add("clicker");
        this.clicker.innerText = "Steps: " + this.clicks;
    }

    getClicks() {
        return this.clicks;
    }

    removeTemplate() {
        this.canvas.remove();
    }

    move(x, y) {
        let emptyX = this.empty.x;
        let emptyY = this.empty.y;
        if (((x - 1 === emptyX || x + 1 === emptyX) && y === emptyY)
         || ((y - 1 === emptyY || y + 1 === emptyY) && x === emptyX)) {
            let temp = this.randArr[emptyY][emptyX];
            this.randArr[emptyY][emptyX] = this.randArr[y][x];
            this.randArr[y][x] = temp;
            this.clicks += 1;
            this.clicker.innerText = "Steps: " + this.clicks;
        }
    }

    rerender() {
        this.ctx.fillStyle = "#222";
        this.ctx.fillRect(0, 0, this.canvas.width, this.canvas.height);
        this.getEmpty();
        this.drawGems();
    }

    doResArr() {
        for (let i = 0; i < (this.size * this.size); i += 1) {
            this.arr1[i] = i;
        }
        this.arr1.shift();
    }

    renderLocal() {
        this.canvas.width = this.width;
        this.canvas.height = this.height;
        this.canvas.id = "canvas";
        document.body.append(this.canvas);
        this.ctx.fillStyle = "#222";
        this.ctx.fillRect(0, 0, this.width, this.height);
        this.getEmpty();
        this.drawGems();
        if (document.querySelector(".clicker")) {
            document.querySelector(".clicker").remove();
            this.renderClicker();
        } else {
            this.renderClicker();
        }
    }

    renderHeader() {
        if (this.canvas) {
            const head = document.createElement("h1");
            head.classList.add("head");
            document.body.append(head);
            head.innerText = "Gem Puzzle";
        }
    }

    render() {
        this.canvas.width = this.width;
        this.canvas.height = this.height;
        this.canvas.id = "canvas";
        const wrapper = document.createElement("div");
        wrapper.classList.add("wrapper");
        document.body.append(wrapper);
        wrapper.append(this.canvas);
        this.ctx.fillStyle = "#222";
        this.ctx.fillRect(0, 0, this.width, this.height);
        this.getViewField();
        this.getEmpty();
        this.drawGems();
        if (document.querySelector(".clicker")) {
            document.querySelector(".clicker").remove();
            this.renderClicker();
        } else {
            this.renderClicker();
        }
        this.doResArr();
    }

    isVictory() {
        if (this.randArr.length > 1) {
            let res = [];
            let victory = true;
            for (let i = 0; i < this.randArr.length; i += 1) {
                for (let j = 0; j < this.randArr[i].length; j += 1) {
                    if (this.randArr[i][j] !== 0) {
                        res.push(this.randArr[i][j]);
                    }
                }
            }
            for (let i = 0; i < res.length; i += 1) {
                if (res[i] !== this.arr1[i]) {
                    victory = false;
                }
            }
            if (victory) {
                alert(`You have won for ${this.clicks} steps`);
                localStorage.setItem("Highscore", this.highscore);
            }
        }
    }

    getField() {
        for (let i = 0; i < (this.size * this.size); i += 1) {
            this.arr[i] = i;
        }
        this.arr.sort(() => {
            return Math.random() - 0.5;
        });
    }

    getViewFieldLocal() {
        this.getField();
        for (let i = 0; i < this.size; i += 1) {
            this.randArr[i] = [];
            for (let j = 0; j < this.size; j += 1) {
                this.randArr[i][j] = this.arr[j + (i * this.size)];
            }
        }
    }

    getViewField() {
        this.getField();
        for (let i = 0; i < this.size; i += 1) {
            this.randArr[i] = [];
            for (let j = 0; j < this.size; j += 1) {
                this.randArr[i][j] = this.arr[j + (i * this.size)];
            }
        }
    }

    setGemsView() {
        this.ctx.font = "bold " + (this.height / 9) + "px serif";
        this.ctx.textAlign = "center";
        this.ctx.textBaseline = "middle";
        this.ctx.fillStyle = "#222";
    }

    drawGemsLocal() {
        for (let i = 0; i < this.localArr.length; i += 1) {
            for (let j = 0; j < this.localArr[i].length; j += 1) {
                if (this.localArr[i][j] !== 0) {
                    this.ctx.fillStyle = "#FFB93B";
                    this.ctx.fillRect(j * this.gemSize, i * this.gemSize,
                        (this.width / this.size) - this.size / 2,
                        (this.height / this.size) - this.size / 2);
                    this.setGemsView();
                    this.ctx.fillText(this.randArr[i][j], (j * this.gemSize) + (this.gemSize / 2),
                        (i * this.gemSize) + (this.gemSize / 2));
                }
            }
        }
    }

    drawGems() {
        for (let i = 0; i < this.randArr.length; i += 1) {
            for (let j = 0; j < this.randArr[i].length; j += 1) {
                if (this.randArr[i][j] !== 0) {
                    this.ctx.fillStyle = "#FFB93B";
                    this.ctx.fillRect(j * this.gemSize, i * this.gemSize,
                        (this.width / this.size) - this.size / 2,
                        (this.height / this.size) - this.size / 2);
                    this.setGemsView();
                    this.ctx.fillText(this.randArr[i][j], (j * this.gemSize) + (this.gemSize / 2),
                        (i * this.gemSize) + (this.gemSize / 2));
                }
            }
        }
    }

    getEmptyLocal() {
        for (let i = 0; i < this.localArr.length; i += 1) {
            for (let j = 0; j < this.localArr[i].length; j += 1) {
                if (this.localArr[i][j] === 0) {
                    this.empty.x = j;
                    this.empty.y = i;
                }
            }
        }
    }

    getEmpty() {
        for (let i = 0; i < this.randArr.length; i += 1) {
            for (let j = 0; j < this.randArr[i].length; j += 1) {
                if (this.randArr[i][j] === 0) {
                    this.empty.x = j;
                    this.empty.y = i;
                }
            }
        }
    }
}
